import { FC, useEffect, useState } from "react";
import classnames from "classnames";
import { observer } from "mobx-react-lite";
import {
  ExpandedTable,
  IButton,
  StoredPagination,
  ITooltip,
} from "../../ui-kit";
import { PlusIco, TrashIco } from "../../assets/customIcons";
import SmsSettingsParamsForm from "./form/incident";
import smsSettings from "../../store/smsSettings";
import { FilterCondition } from "../../constants/Enums";
import { useStatusMessage } from "../../hooks/useStatusMessage";

import styles from "./SmsSettings.module.scss";
import Constants from "../../constants/Common";

type IInterval = {
  value: number,
  valueTo: number,
  conditionType: FilterCondition,
}

export type IIncidentItem = {
  id?: number
  name: string
  buildingsOff: IInterval
  abonentsOff: IInterval
  diameter: IInterval
  useForMajorAccident: boolean
}

const INITIAL_INCIDENT_DATA: IIncidentItem = {
  id: 0,
  name: null,
  buildingsOff: {
    value: null,
    valueTo: null,
    conditionType: FilterCondition.Equal,
  },
  abonentsOff: {
    value: null,
    valueTo: null,
    conditionType: FilterCondition.Equal,
  },
  diameter: {
    value: null,
    valueTo: null,
    conditionType: FilterCondition.Equal,
  },
  useForMajorAccident: false
};

const SmsIncidentParams: FC = observer(() => {
  const {
    titleIcons: { trash },
  } = Constants;
  const [addForm, toggleAddForm] = useState(false);
  const {
    incidentParamsStatus,
    incidentsParamsAreLoading,
    incidentsParamsData,
    incidentsParamsDataPaginator,
    incidentParamsRowKeys,
  } = smsSettings;

  useStatusMessage(incidentParamsStatus);

  useEffect(() => {
    smsSettings.getSmsIncidentsParams();
  }, [incidentsParamsDataPaginator.page, incidentsParamsDataPaginator.perPage]);

  const columns = [
    {
      title: "№",
      dataIndex: "id",
      key: "id",
      render: (text, record, index) => index + 1,
      width: "5%",
    },
    {
      title: "Название шаблона",
      dataIndex: "name",
      key: "name",
      className: "align-left",
      width: "95%",
    },
    {
      title: " ",
      key: "delete",
      render: (text, record, index) => (
        <ITooltip title={trash} placement="right">
          <TrashIco onClick={(e) => deleteData(e, record.id)} />
        </ITooltip>
      ),
      className: "delete-cell",
    },
  ];

  const deleteData = (e, id) => {
    e.stopPropagation();

    smsSettings.deleteSmsIncidentsParam(id);
  };

  return (
    <div
      className={classnames(
        styles.SmsSettingsPage,
        styles.SmsIncidentParamsSettingsPage,
      )}
    >
      <ExpandedTable
        columns={columns}
        data={incidentsParamsData}
        rowKey={(record) => record.id+record.useForMajorAccident}
        rowKeys={incidentParamsRowKeys.keys}
        setRowKeys={incidentParamsRowKeys.setKeys}
        rowsLength={incidentsParamsDataPaginator.perPage}
        loading={incidentsParamsAreLoading.value}
      >
        <SmsSettingsParamsForm />
      </ExpandedTable>
      <StoredPagination {...incidentsParamsDataPaginator} />
      <IButton
        size="medium"
        onClick={(e) => toggleAddForm((addForm) => !addForm)}
        className={styles.SmsSettingsAddButton}
      >
        <PlusIco /> Добавить шаблон
      </IButton>
      {addForm && <SmsSettingsParamsForm record={INITIAL_INCIDENT_DATA} />}
    </div>
  );
});

export default SmsIncidentParams;
